// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"7d49b426","270":"c0931ea3","323":"0f2b5307","776":"fd2659a3","808":"bd4bf66a","827":"aafd0c3c","922":"7d199470"}[chunkId] + ".chunk.js";
};